import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function fetchMultiple(autoGeneratedIdArray) {
  try {
    const url = paths.getMultipleDetails();
    const response = await axiosInstance.post(url, autoGeneratedIdArray);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useFetchMultiple = () => {
  return useMutation((autoGeneratedIdArray) => fetchMultiple(autoGeneratedIdArray));
};

export { useFetchMultiple };
